var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18945 11.085H6.55273V18.96H3.03711V11.085H0.154297V7.85059H3.03711V5.35449C3.03711 2.54199 4.72461 0.959961 7.29102 0.959961C8.52148 0.959961 9.82227 1.20605 9.82227 1.20605V3.9834H8.38086C6.97461 3.9834 6.55273 4.82715 6.55273 5.74121V7.85059H9.68164L9.18945 11.085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f9bc502b68adcf449b70cbf5d7220413.svg";
export { ForwardRef as ReactComponent };